// extracted by mini-css-extract-plugin
var _1 = "dtmbO";
var _2 = "Ry4QE";
export { _1 as "input", _2 as "wrapper" }
